import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

const Toggle = ({ toggleTitle, toggleText, checked, onChange }) => {
  const [inputChecked, setInputChecked] = useState(false);

  useEffect(() => {
      setInputChecked(checked);
  }, [checked]);

  const handleChange = (e) => {
    setInputChecked(!inputChecked);
    if (onChange) {
      onChange(!inputChecked);
    }
  };

  const renderToggle = () => (
    <label className="toggle">
      <input type="checkbox" checked={inputChecked} onChange={handleChange} />
      {inputChecked ? (
        <span className="toggle__slider toggle__slider--true">{toggleText}</span>
      ) : (
        <span className="toggle__slider toggle__slider--false">{toggleText}</span>
      )}
    </label>
  );

  const renderToggleSmall = () => (
    <div className='toggle__flex'>
      <p className="toggle__title">{toggleTitle}</p>
      <label className={classnames('toggle--small', { checked: inputChecked })}>
        <span className="sr-only">{toggleTitle}</span>
        <input type="checkbox" checked={inputChecked} onChange={handleChange} />
        <span className="toggle--small__slider" />
      </label>
    </div>
  );

  return <>{toggleTitle ? renderToggleSmall() : renderToggle()}</>;
};

export default Toggle;
